/**
 * These assemblies can be used in Rich Text Editors
 * and in other components found in the Components map.
 *
 * These components cannot embed others. They are "terminal"
 * components that prevent the creation of Circular References.
 *
 * They can contain Rich Text Editors, as long as those Editors
 * do not allow embeds.
 */
import { mapValues } from 'lodash';
import { SafeAssembly } from '../../error-boundaries';

// keep this list in alphabetical order
import { AccordionAssembly } from '../../accordion';
import { AlertCalloutAssembly } from '../../alert-callout';
import { SearchBoxAssembly } from '../../search-box';
import { ContentCardBannerAssembly } from '../../content-card-banner';
import { CTAAssembly } from '../../cta';
import { CTABannerAssembly } from '../../cta-banner';
import { DatawrapperAssembly } from '../../datawrapper';
import { DownloadBannerAssembly } from '../../download-banner';
import { GraphAssembly } from '../../graph';
import { IframeEmbedAssembly } from '../../iframe-embed';
import { InlineCalloutAssembly } from '../../inline-callout';
import { MapAssembly } from '../../map';
import { TableAssembly } from '../../table';
import { VideoEmbedAssembly } from '../../video';
import { LookupAssembly } from '../../lookup';
import { WebchatCtaAssembly } from '../../webchat-cta';

// keep this list in alphabetical order
const map = {
  ContentfulComponentAccordion: AccordionAssembly,
  ContentfulComponentAlertCallout: AlertCalloutAssembly,
  ContentfulAssemblyContentCardsBanner: ContentCardBannerAssembly,
  ContentfulAssemblyCta: CTABannerAssembly,
  ContentfulComponentCtaWithIcon: CTAAssembly,
  ContentfulBlockDatawrapper: DatawrapperAssembly,
  ContentfulAssemblyDownloadBanner: DownloadBannerAssembly,
  ContentfulComponentSearchBox: SearchBoxAssembly,
  ContentfulComponentGraph: GraphAssembly,
  ContentfulComponentGoogleMap: MapAssembly,
  ContentfulComponentIframeEmbed: IframeEmbedAssembly,
  ContentfulComponentInlineCallout: InlineCalloutAssembly,
  ContentfulComponentLookup: LookupAssembly,
  ContentfulComponentStandardCta: CTAAssembly,
  ContentfulComponentTable: TableAssembly,
  ContentfulComponentVideoEmbed: VideoEmbedAssembly,
  ContentfulComponentWebchatCta: WebchatCtaAssembly,
};

export default mapValues(map, (component) => SafeAssembly(component));
